import { render, staticRenderFns } from "./FullTextPdfDropzone.vue?vue&type=template&id=4b35b2d6&scoped=true&"
import script from "./FullTextPdfDropzone.vue?vue&type=script&lang=js&"
export * from "./FullTextPdfDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FullTextPdfDropzone.vue?vue&type=style&index=0&id=4b35b2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35b2d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
